import React from 'react';

export default function ReviewQuote({text, source}) {
  return (
    <>
      <p>{text}</p>
      <span className='highlight'>{source}</span>
    </>
  );
}
